import React, { createContext, useContext } from "react";
import { Modal } from "antd";

const ModalContext = createContext();

export const SuccessModalProvider = ({ children }) => {
  const [modal, contextHolder] = Modal.useModal();

  const showPopup = ({
    title,
    content,
    onOk,
    okText = "OK",
    className,
    style,
  }) => {
    modal.confirm({
      title,
      content,
      onOk,
      okText,
      icon: null,
      className,
      style,
      cancelButtonProps: { style: { display: "none" } },
    });
  };

  return (
    <ModalContext.Provider value={{ showPopup }}>
      {contextHolder}
      {children}
    </ModalContext.Provider>
  );
};

export const useGlobalModal = () => useContext(ModalContext);
